import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import some from 'lodash/some';
import APP_STATUS from '@integrations/pint-appstore-commons/src/enums/APP_STATUS.json';
import { addApp } from '../appStatusActionCreators';
import { openSettingsInfoPopup } from '../appSettingsActionCreators';
import { openRemove } from '../../appRemove/appRemoveActionCreators';
import {
    StatusSpan,
    AddButton,
    ConfigButton,
    RemoveButton,
    ViewDetailsButton,
    AskAdminToEnableIntegrations,
} from './appActionsItems';
import APPACTIONS_DISPLAY_VARIANT from '../../../enums/APPACTIONS_DISPLAY_VARIANT';

const remove = (props) => () => {
    props.dispatchOpenRemove(props.appId, props.name);
};
const add = (props) => () => {
    props.dispatchAddApp(props.appId, props.name, props.userSettings);
};

const Added = (props) => {
    const configure = () => {
        props.dispatchOpenSettingsInfoPopup({
            appId: props.appId,
            name: props.name,
            settingsURL: props.userSettings,
        });
    };

    return (
        <div>
            <StatusSpan text="Added" />
            <ConfigButton disabled={!props.userSettings} action={configure} />
            {props.status !== APP_STATUS.ALLOWED_ADDED_USER ? (
                <RemoveButton disabled />
            ) : (
                <RemoveButton action={remove(props)} />
            )}
        </div>
    );
};
Added.propTypes = {
    appId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    dispatchOpenSettings: PropTypes.func.isRequired,
    dispatchOpenSettingsInfoPopup: PropTypes.func.isRequired,
    userSettings: PropTypes.string,
};

const Allowed = (props) => <AddButton isAvailable={props.isAvailable} action={add(props)} />;

const Disabled = (props) => {
    if (props.variant !== APPACTIONS_DISPLAY_VARIANT.APP_DETAILS) {
        return <ViewDetailsButton {...props} />;
    }

    return <span className="appActions-message"> Ask your admin to enable this integration </span>;
};
Disabled.propTypes = {
    variant: PropTypes.string.isRequired,
};

const AddedForGroups = (props) => {
    const userHasGroup = some(props.userGroups, (group) => props.appGroups.includes(group.id));

    if (userHasGroup) {
        return <Added {...props} />;
    }

    return props.variant === APPACTIONS_DISPLAY_VARIANT.APP_DETAILS ? (
        <AskAdminToEnableIntegrations />
    ) : (
        <ViewDetailsButton {...props} />
    );
};
AddedForGroups.propTypes = {
    appId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    dispatchOpenSettings: PropTypes.func.isRequired,
    dispatchOpenSettingsInfoPopup: PropTypes.func.isRequired,
    userSettings: PropTypes.string,
    appGroups: PropTypes.array.isRequired,
    userGroups: PropTypes.array.isRequired,
    variant: PropTypes.string.isRequired,
};

function UserAppActions(props) {
    switch (props.status) {
        case APP_STATUS.ALLOWED_ADDED_USER:
        case APP_STATUS.ADDED_DOMAIN: {
            return <Added {...props} />;
        }
        case APP_STATUS.ALLOWED: {
            return <Allowed {...props} />;
        }
        case APP_STATUS.DISABLED: {
            return <Disabled {...props} />;
        }
        case APP_STATUS.ADDED_FOR_DOMAIN_GROUPS: {
            return <AddedForGroups {...props} />;
        }
        default: {
            return <ViewDetailsButton {...props} />;
        }
    }
}
UserAppActions.propTypes = {
    status: PropTypes.string,
    dispatchAddApp: PropTypes.func.isRequired,
    dispatchOpenRemove: PropTypes.func.isRequired,
    dispatchOpenSettingsInfoPopup: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
    dispatchAddApp: addApp,
    dispatchOpenRemove: openRemove,
    dispatchOpenSettingsInfoPopup: openSettingsInfoPopup,
};

export default connect(null, mapDispatchToProps)(UserAppActions);
